module.exports = __webpack_public_path__ + "img/menu-bg6.8174b890.png";